import procedurePricingReducer from './ProcedurePricingReducer';
import messageTrackingReducer from './MessageTrackingReducer';
import storeSettingReducer from './storeSettingReducer';
import storeContactReducer from './StoreContactReducer'
import visionWebReducer from './visionWebReducer';
import faitReducer from './faitReducer';
import connectDevicesReducer from './connectDevicesReducer';
import integrationLogsReducer from './integrationLogsReducer';
import promotionReducer from './promotionReducer';

const storeSettingsReducers ={
  procedurePricing: procedurePricingReducer,
  messageTracking: messageTrackingReducer,
  storeSetting: storeSettingReducer,
  storeContactSetting: storeContactReducer,
  visionWeb: visionWebReducer,
  fait: faitReducer,
  connectDevices: connectDevicesReducer,
  integrationLogs: integrationLogsReducer,
  storePromotion: promotionReducer,
};

export default storeSettingsReducers;
